<template>
  <div>
    <div id="aaa"></div>

    <van-nav-bar
          fixed
          title="影像中心列表"
          left-arrow
          @click-left="onClickLeft"
        />
        <!-- -------- -->
        <form action="/">
        <van-search
          v-model="message"
          show-action
          shape="round"
          background="#fff"
          placeholder="请输入中心名称"
          @search="onSearch"
          @cancel="onCancel"
        />
        </form>
        <van-radio-group v-model="radio">
          <van-cell-group>
            <van-cell 
              v-for="(item,index) in serachList" 
              :key="index" 
              :title="item.name"  
              clickable 
              @click="selectedIndex(item.id)"
            >
              <van-radio slot="right-icon" :name="item.id" />
            </van-cell>
          </van-cell-group>
        </van-radio-group>
        <!-- ---------- -->
  </div>
</template>

<script>
import  { NavBar,  RadioGroup, Radio, Search } from 'vant';
import { mapState,mapMutations } from 'vuex';
export default {
  components:{
    [NavBar.name]:NavBar,
    [Search.name]:Search,
    [RadioGroup.name]:RadioGroup,
    [Radio.name]:Radio
  },
  data(){
    return{
      radio: '',
      message:'',
      serachList:[]
    }
  },
  methods: {
    ...mapMutations(['changeDefaultAgentIndex']),
    onClickLeft() {
      this.$router.go(-1)
    },
    selectedIndex(index) {
      this.changeDefaultAgentIndex(index);
      this.$router.go(-1)
    },
    onSearch(val) {
      this.serachList = this.initSearchList(val);
    },
    onCancel() {
      this.serachList = this.initSearchList(this.message);
    },
    
    initSearchList(val) {
      if(!val) {
        //window.console.log(this.permissionAgent);
        return this.permissionAgent;
      } else {
        //let _this = this;
        return this.permissionAgent.filter(function(elem){
          return elem.name.indexOf(val) > -1;
        });
        //window.console.log(ses);
      }
    }
    
  },
  created() {
    this.radio = this.defaultAgentIndex;
    //window.console.log(this.defaultAgentIndex);
    this.serachList = this.initSearchList(this.message);
    
  },
  computed:{
    ...mapState(['permissionAgent','defaultAgentIndex']),
    
  },

}
</script>

<style scoped lang="less">
.van-nav-bar{
  /*background: #456;*/
    background: #ffffff;color:#323233;font-weight: bold
  /*color:white;*/
}
.van-nav-bar__title{
  font-weight: 800;
  color:#323233;
}
#aaa{
  width:100vw;
  height:46px;
}
</style>